import HomeLayout from './HomeLayout'

export default HomeLayout